// import Vue from 'vue';
import { MessageBox } from "element-ui";

const showConfirmDialog = (options) => {
  return new Promise((resolve, reject) => {
    MessageBox.confirm(options.message, options.title || "系统提示", {
      confirmButtonText: options.confirmButtonText || "确定",
      cancelButtonText: options.cancelButtonText || "关闭",
      type: options.type || "warning",
    })
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

export default {
  install(Vue) {
    Vue.prototype.$confirmDialog = showConfirmDialog;
  },
};
